import { useState, useLayoutEffect, useEffect } from 'react';
import debounce from 'lodash.debounce';
/* istanbul ignore next */
var globalWindow = typeof window !== 'undefined' ? window : null;
var useIsomorphicLayoutEffect = globalWindow ? useLayoutEffect : useEffect;
/**
 * Detects screen size from window object
 * @param ignoreScreenSize
 * @returns
 */
function detectScreenSize(ignoreScreenSize) {
    if (!globalWindow || ignoreScreenSize) {
        return { width: 0, height: 0 };
    }
    else {
        return { width: globalWindow.innerWidth, height: globalWindow.innerHeight };
    }
}
/**
 * Encapsulates detection of window dimensions
 * @param props
 * @returns Screen with in pixels
 */
export function useDetectWindowSize(props) {
    var _a = props.debounceResize, debounceResize = _a === void 0 ? false : _a, _b = props.debounceDelay, debounceDelay = _b === void 0 ? 50 : _b, _c = props.ignoreWindowSize, ignoreWindowSize = _c === void 0 ? !globalWindow : _c;
    // screen width in px
    var _d = useState(function () {
        return detectScreenSize(ignoreWindowSize);
    }), screenSize = _d[0], setScreenSize = _d[1];
    useIsomorphicLayoutEffect(function screenResizeEffect() {
        function updateScreenSize() {
            setScreenSize(detectScreenSize(ignoreWindowSize));
        }
        var resizeHandler = debounceResize
            ? debounce(updateScreenSize, debounceDelay)
            : updateScreenSize;
        var orientationHandler = updateScreenSize;
        // add event listeners for screen events
        if (globalWindow) {
            globalWindow.addEventListener('resize', resizeHandler);
            globalWindow.addEventListener('orientationchange', orientationHandler);
        }
        // cleanup effect: remove all event listeners
        return function () {
            if (globalWindow) {
                globalWindow.removeEventListener('resize', resizeHandler);
                globalWindow.removeEventListener('orientationchange', orientationHandler);
            }
        };
    }, [ignoreWindowSize, debounceResize, debounceDelay]);
    return screenSize;
}
//# sourceMappingURL=useDetectWindowSize.js.map